import { useLang } from '../../../../../hooks/use-lang';
import { useToggle } from '../../../../../hooks/use-toggle';
import { useCompanyStore } from '../../../../../store/use-company-store';
import { useImageStore } from '../../../../../store/use-image-store';
import { IdValue } from '../../../../../types/props';

const defaultFonts: IdValue[] = [
  'VAG',
  'Arial',
  'Verdana',
  'Helvetica',
  'Tahoma',
  'Trebuchet MS',
  'Times New Roman',
  'Georgia',
  'Garamond',
  'Courier New',
  'Brush Script MT',
  'Comic Sans MS',
  'Impact',
  'Lucida Sans Unicode',
  'Palatino Linotype',
  'Segoe UI',
].map((item) => ({ id: item, value: item }));

export const useAppSettings = () => {
  const [disabled, toggleDisabled, setDisabled] = useToggle(true);
  const {
    isLoading,
    handleSaveCompanyProfile,
    handleResetCompanyProfile,
    handleUpdateCompanyProfile,
    companyProfile,
  } = useCompanyStore();
  const [isImage, toggleIsImage] = useToggle();
  const { postImage, isLoading: isSavingImage } = useImageStore();

  const { t } = useLang();
  const name = companyProfile?.name || '';

  const handleCancel = () => {
    handleResetCompanyProfile();
    setDisabled(true);
  };

  const handleSave = () => {
    handleSaveCompanyProfile().then(() => setDisabled(true));
  };

  const handleUploadLogo = (file?: File[]) => {
    if (!file) {
      handleUpdateCompanyProfile({ app: { ...companyProfile?.app, logo: undefined } });
      return;
    }
    const formData = new FormData();
    formData.append('image', file[0]);
    postImage(formData).then((resp) =>
      handleUpdateCompanyProfile({ app: { ...companyProfile?.app, logo: resp } }),
    );
  };

  const handleUploadBg = (file?: File[]) => {
    if (!file) {
      handleUpdateCompanyProfile({ app: { ...companyProfile?.app, background: undefined } });
      return;
    }
    const formData = new FormData();
    formData.append('image', file[0]);
    postImage(formData).then((resp) =>
      handleUpdateCompanyProfile({ app: { ...companyProfile?.app, background: resp?.normal } }),
    );
  };

  const logo =
    companyProfile?.app?.logo?.normal || companyProfile?.app?.logo?.thumbnail || undefined;
  const background = companyProfile?.app?.background;

  return {
    disabled,
    toggleDisabled,
    isLoading,
    handleCancel,
    handleSave,
    t,
    name,
    handleUpdateCompanyProfile,
    app: companyProfile?.app,
    defaultFonts,
    handleUploadLogo,
    handleUploadBg,
    isSavingImage,
    isImage,
    toggleIsImage,
    logo,
    background,
  };
};
